import { render, staticRenderFns } from "./MusicListPh.vue?vue&type=template&id=3e1db725&scoped=true&"
import script from "./MusicListPh.vue?vue&type=script&lang=js&"
export * from "./MusicListPh.vue?vue&type=script&lang=js&"
import style0 from "./MusicListPh.vue?vue&type=style&index=0&id=3e1db725&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1db725",
  null
  
)

export default component.exports